let unshiftAll  = (arr,keyName="ID",valueName="Name") => {
    arr = Object.assign([],arr);
    let option = {};
    option[keyName] = "all";
    option[valueName] = "All";
    arr.unshift(option);
    return arr;
};

export { unshiftAll }; 